import React from 'react';
import { getEc2Specs, formatMemory } from '../../utils/ec2Specs';

/**
 * Card homologado de specs de la máquina (EC2) para los detalles de marketplace.
 * Muestra instancia, vCPU, RAM, almacenamiento y región derivados del servicio,
 * igual que en app-deploy. vCPU/RAM se derivan del instanceType.
 */

interface MachineSpecsCardProps {
  service: any;
  className?: string;
}

const Spec: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div>
    <p className="text-xs text-gray-500 dark:text-gray-400">{label}</p>
    <p className="text-sm font-semibold text-gray-900 dark:text-white mt-0.5">{value}</p>
  </div>
);

const MachineSpecsCard: React.FC<MachineSpecsCardProps> = ({ service, className }) => {
  const instanceType: string | undefined = service?.instanceType;
  const specs = getEc2Specs(instanceType);
  const region = service?.region || service?.metadata?.region || '-';
  const volumeGB =
    service?.volumeGB ??
    service?.metadata?.volumeGB ??
    service?.metadata?.wordpressConfig?.volumeGb ??
    service?.metadata?.sqlserverConfig?.volumeGb ??
    null;

  return (
    <div
      className={`bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700 p-5 ${className || ''}`}
    >
      <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-4">Máquina</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <Spec label="Instancia" value={instanceType || '-'} />
        <Spec label="vCPU" value={specs ? specs.vcpu : '-'} />
        <Spec label="RAM" value={specs ? formatMemory(specs.memoryMB) : '-'} />
        <Spec label="Almacenamiento" value={volumeGB ? `${volumeGB} GB` : '-'} />
      </div>
      <div className="mt-4 pt-3 border-t border-gray-200 dark:border-gray-700">
        <Spec label="Región" value={region} />
      </div>
    </div>
  );
};

export default MachineSpecsCard;
